import React, { useState, useEffect, useContext } from "react";
import useInterval from "lib/useInterval";
import pb from "lib/pocketbase";
import { UserContext } from "lib/UserContext";

export default function CommentsCard(props) {
  const { user, setUser } = useContext(UserContext);
  // const [loading, setLoading] = useState(true);
  const [commentCardStyle, setCommentCardStyle] = useState({});

  function getCommentCardStyle() {
    if (
      user.public_comments_today === user.daily_goal &&
      user.public_comments_today > 0
    ) {
      return { check: "✓", bg: "bg-success" };
    } else {
      return { check: "", bg: "bg-primary" };
    }
  }
  useEffect(() => {
    fetch(`https://zendash.fly.dev/api/collections/users/records/${user.id}`)
      .then((response) => response.json())
      .then((record) => {
        console.log(`public comments today: ${record.public_comments_today}`);
        setUser(record);
        setCommentCardStyle(getCommentCardStyle());
      });
  }, []);

  useInterval(() => {
    fetch(`https://zendash.fly.dev/api/collections/users/records/${user.id}`)
      .then((response) => response.json())
      .then((record) => {
        console.log(record.public_comments_today);
        setUser(record);
        setCommentCardStyle(getCommentCardStyle());
      });
  }, 60000);

  return (
    <div className="card shadow text-center mb-2">
      <h6 className={`card-header ${commentCardStyle.bg} text-white p-2`}>
        {commentCardStyle.check} Public Comments Today
      </h6>
      <div className={`card-body d-flex flex-column align-items-center`}>
        <div className="card-text d-inline-flex">
          <h3 className="me-2">{user.public_comments_today}</h3>
          {user.daily_goal !== 0 && (
            <span className="text-muted text-center">of {user.daily_goal}</span>
          )}
        </div>{" "}
        {user.daily_goal !== 0 && (
          <progress
            value={user.public_comments_today}
            max={user.daily_goal}
          ></progress>
        )}
      </div>
    </div>
  );
}
